import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { Stack } from '@chakra-ui/layout';

interface SummaryActivitiesProps {
  value: number;
  title: string;
  variant?:
    | 'default'
    | 'blue'
    | 'dark-blue'
    | 'green'
    | 'red'
    | 'yellow'
    | 'purple';
  isLink?: boolean;
  to?: string;
  image?: string;
  warning?: boolean;
  imageSize?: string;
}

export const SummaryActivities: React.VFC<SummaryActivitiesProps> = ({
  value,
  title,
  variant = 'default',
  isLink = false,
  to = '',
  image,
  warning = false,
  imageSize = '45px',
}) => {
  const history = useHistory();

  function handleNavigate() {
    if (isLink) {
      history.push(to);
    }
  }
  const backgroundColor = () => {
    switch (variant) {
      case 'blue':
        return '#71C5E833';
      case 'dark-blue':
        return '#4F95FF33';
      case 'green':
        return '#49C5B133';
      case 'red':
        return '#FF8DA133';
      case 'yellow':
        return '#FFC56E33';
      case 'purple':
        return '#9563BE33';
      default:
        return '#f5f5f5';
    }
  };
  const borderColor = () => {
    switch (variant) {
      case 'blue':
        return '#71C5E8';
      case 'dark-blue':
        return '#4F95FF';
      case 'green':
        return '#49C5B1';
      case 'red':
        return '#FF8DA1';
      case 'yellow':
        return '#FFC56E';
      case 'purple':
        return '#9563BE';
      default:
        return '#cccccc';
    }
  };

  return (
    <Box
      backgroundColor={backgroundColor()}
      borderColor={borderColor()}
      borderWidth="1px"
      paddingTop={5}
      paddingBottom={5}
      paddingLeft={3}
      paddingRight="0"
      color={warning ? '#F66451' : 'black'}
      minW="10vw"
      width="16%"
      borderRadius={8}
      minHeight={90}
      height="fit-content"
      onClick={() => handleNavigate()}
      cursor={isLink ? 'pointer' : 'normal'}
    >
      <Box>
        <Box position="relative">
          <Stack
            borderRadius="50%"
            backgroundColor={borderColor()}
            minW="60px"
            alignItems="center"
            verticalAlign="middle"
            height="60px"
            position="absolute"
            marginTop="-15px"
            right="5px"
          >
            <Text margin="auto">
              <img src={image} alt="" width={imageSize} height={imageSize} />
            </Text>
          </Stack>
        </Box>
        <Stack>
          <Text fontSize="xx-large" fontWeight="extrabold">
            {value}
          </Text>
          <Text marginTop="0px !important" fontSize="0.9rem">
            {title}
          </Text>
        </Stack>
      </Box>
    </Box>
  );
};
